import { render, staticRenderFns } from "./modifyList.vue?vue&type=template&id=9ed5b3c6&lang=pug"
import script from "./modifyList.vue?vue&type=script&lang=js"
export * from "./modifyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports